import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	Input,
	Label,
	ErrorMsg,
} from './inputStyles';

import { randomNumber } from '../helpers';

class StyledInput extends PureComponent {
	render () {
		const { placeholder, className, errorMsg, ...props } = this.props;
		const id = randomNumber();

		return (
			<Wrapper className={className} invalid={!!errorMsg}>
				<Input id={id} required {...props} invalid={!!errorMsg} />
				<Label htmlFor={id}>{placeholder}</Label>
				<ErrorMsg show={!!errorMsg}>{errorMsg}</ErrorMsg>
			</Wrapper>
		);
	}
}

StyledInput.propTypes = {
	placeholder: PropTypes.string.isRequired,
	className: PropTypes.string,
	errorMsg: PropTypes.string,
};

export default StyledInput;
